import { Box, chakra } from '@chakra-ui/react'

type Props = {
  title?: string
  data?: any
}

export const PrettyPrintJSON = (props: Props) => {
  let printedJson

  if (process.env.NEXT_PUBLIC_DEPLOYMENT_ENV === 'production') {
    return <></>
  }

  try {
    printedJson = JSON.stringify(props.data, null, 2)
  } catch (err) {
    return (
      <Box>
        {'Error: '}
        {err.toString()}
      </Box>
    )
  }

  return (
    <Box
      backgroundColor={'colorPalette.subtle'}
      borderRadius={'lg'}
      maxWidth={'100%'}
      overflow={'scroll'}
      padding={'4'}
    >
      {props.title && (
        <chakra.pre
          borderBottom={'1px solid'}
          borderBottomColor={'border.emphasized'}
          display={'block'}
          marginBottom={2}
          paddingBottom={2}
        >
          {props.title}
        </chakra.pre>
      )}
      <pre>{printedJson}</pre>
    </Box>
  )
}
